import React, { useState } from 'react';

import {
  Button,
  Icon,
} from 'src/components/Component';

import DataTable from 'src/components/data-table';
import API_ROUTES from "../../../../config/api";
import { Auth } from "aws-amplify";
import axios from "axios";
import { Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import ActivateComponent from './components/activate';
import PiiObfuscator from "../../../../components/pii-obfuscator";
import { useSelector } from 'react-redux';
import { BuildingLibraryIcon } from '@heroicons/react/24/outline';

const RowFormatter = ({ item, triggerReload, childFilterState }) => {
  return (
    <tr className="tb-tnx-item">
      {childFilterState === true && (
        <td>
          <span className="title">{item.organisation.name}</span>
        </td>
      )}
      <td>
        <PiiObfuscator className="date" type="iban">{item.bank.iban}</PiiObfuscator>
      </td>
      <td>
        <PiiObfuscator className="date" type="company">{item.bank.name}</PiiObfuscator>
      </td>
      <td>
        <PiiObfuscator className="date" type="account_number">{item.bank.account_number}</PiiObfuscator>
      </td>
      <td>
        <span className="date">{item.bank.sort_code}</span>
      </td>
      <td className="w-100px text-center">
        {item.is_active && (
          <Icon name={`ni text-primary icon ni-check pr-1`} />
        )}
        {!item.is_active && (
          <ActivateComponent data={item} triggerReload={triggerReload} />
        )}
      </td>
    </tr>
  );
}

const PageOptions = ({ requestParams }) => {
  const [fetchingCSV, setFetchingCSV] = useState(false);

  const createCSV = async () => {
    setFetchingCSV(true);

    const user = await Auth.currentAuthenticatedUser();

    const response = await axios.post(
      API_ROUTES.ledger['beneficiaries:get'](),
      { ...requestParams, type: 'csv' },
      {
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    setFetchingCSV(false);
    window.location.href = response.data.data.url;
  }

  return (
    <ul className="nk-block-tools g-3">
      <li>
        <Button disabled={fetchingCSV} className="border-violet-800 bg-white text-violet-800 text-xs hover:bg-slate-800 hover:border-slate-800" id="link_generate_csv" onClick={() => createCSV()}>
          {
            fetchingCSV === true ? (
              <React.Fragment>
                <Spinner size="sm" color="primary" className="mr-2"> </Spinner> Preparing CSV
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Icon name="download" />
                <span>Export</span>
              </React.Fragment>
            )
          }
        </Button>
      </li>
    </ul>
  );
};

const TopBlock = () => {
  const { organisation: { is_admin } } = useSelector((state) => state);

  if (is_admin === false) {
    return <React.Fragment />;
  }

  return (
    <div className="clearfix border border-red-200 border-stroke pl-0 py-2 bg-red-50 text-violet-800 pl-2 relative rounded-md mb-4">
      <div className="text-sm px-2 font-bold bg-red-500 text-white border-l absolute h-100 top-0 right-0 pt-[20px]">
        <strong>God Mode</strong>
      </div>

      <Link to='/organisation/beneficaries/create'>
        <button className="btn bg-white hover:text-red-900 hover:bg-red-200 text-red-700 border border-red-700 float-left">
          <BuildingLibraryIcon className="h-5 w-5 mr-2" />
          Add Beneficiary
        </button>
      </Link>
    </div>
  )
}

const TableHeaders = ({ childFilterState }) => (
  <tr className="tb-tnx-head">
    {childFilterState === true && (
      <th>
        <span>Organisation</span>
      </th>
    )}
    <th>
      <span>IBAN</span>
    </th>
    <th>
      <span>Account Name</span>
    </th>
    <th>
      <span>Account Number</span>
    </th>
    <th>
      <span>Sort Code</span>
    </th>
    <th className="text-center">
      <span>Enabled</span>
    </th>
  </tr>
);

const Beneficiaries = () => {
  const endpoint = API_ROUTES.ledger['beneficiaries:get']();

  return (
    <DataTable
      title="Beneficiaries"
      searchPlaceholder="IBAN or Account Number"
      columnCount={5}
      TopBlock={TopBlock}
      TableHeaders={TableHeaders}
      RowFormatter={RowFormatter}
      PageOptions={PageOptions}
      endpoint={endpoint}
      childOrganisationsOption={true}
      noHeader={true}
    />
  );
};

export default Beneficiaries;
